export default __webpack_public_path__ + "static/media/maintenance.d8b29f12.png";